import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { FaPeopleRoof } from 'react-icons/fa6'
import { IoIosPeople } from 'react-icons/io'
import { MdManageHistory } from 'react-icons/md'

function ContentLetter() {
    return (
        <div className='home-content-letter'>
            <div className='bg-success home-gap'>
                <Container>
                    <Row className='gy-3'>
                        <Col className='col-12 col-md-6'>
                            <h2 className='m-0 fw-semibold fs-48 fs-md-25 fs-sm-20' data-aos="fade-right">The cups we make can make your business</h2>
                        </Col>
                        <Col className='col-12 col-md-6'>
                            <p className='fs-md-14 fs-sm-12 m-0 mt-3' data-aos="fade-left" data-aos-delay="150">As a leading paper cup company we are dedicated to manufacture great quality paper cups to meet the need of a variety of service applications within the food service industry.</p>
                        </Col>
                    </Row>
                    <hr className='my-4' />
                    <Row className='gy-3'>
                        {/* <Col className='col-12 col-md-6 col-lg-4 gap-3 d-grid'>
                            <FaPeopleRoof className='text-contra fs-48' data-aos="fade-up" />
                            <div className='d-grid gap-1'>
                                <h5 className='m-0 fw-semibold fs-18 fs-md-16 fs-sm-14' data-aos="fade-up" data-aos-delay="150">Our Culture</h5>
                                <p className='fs-14 fs-md-12 fs-sm-10 m-0' data-aos="fade-up" data-aos-delay="300">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, </p>
                            </div>
                        </Col>
                        <Col className='col-12 col-md-6 col-lg-4 gap-3 d-grid'>
                            <IoIosPeople className='text-contra fs-48' data-aos="fade-up" />
                            <div className='d-grid gap-1'>
                                <h5 className='m-0 fw-semibold fs-18 fs-md-16 fs-sm-14' data-aos="fade-up" data-aos-delay="150">Our Team</h5>
                                <p className='fs-14 fs-md-12 fs-sm-10 m-0' data-aos="fade-up" data-aos-delay="300">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, </p>
                            </div>
                        </Col> */}
                        <Col className='col-12 gap-3 d-flex'>
                            <div style={{ width: "55px" }}>
                                <MdManageHistory className='text-contra fs-48' data-aos="fade-up" />
                            </div>
                            <div className='d-grid gap-2'>
                                <h5 className='m-0 fw-semibold fs-18 fs-md-16 fs-sm-14' data-aos="fade-up" data-aos-delay="150">Our History</h5>
                                <p className='fs-14 fs-md-12 fs-sm-10 m-0' data-aos="fade-up" data-aos-delay="300">
                                    Nexus was established in 2021 with a vision to lead the way in sustainable packaging solutions for the global beverage industry. As a manufacturer of eco-friendly paper cups, including single wall, double wall, and ripple wall options, we are dedicated to providing high-quality, environmentally responsible products to businesses around the world.
                                </p>
                                <p className='fs-14 fs-md-12 fs-sm-10 m-0' data-aos="fade-up" data-aos-delay="300">
                                    Our journey began with a passion for reducing environmental impact while delivering durable, cost-effective, and stylish solutions for hot and cold beverages. Since our inception, we have expanded our reach globally, serving a wide range of industries from cafes and restaurants to offices and large-scale events.
                                </p>
                                <p className='fs-14 fs-md-12 fs-sm-10 m-0' data-aos="fade-up" data-aos-delay="300">
                                    At Nexus, we combine advanced manufacturing processes with a strong commitment to sustainability, ensuring that each cup is made from responsibly sourced materials, designed to reduce waste and support a greener future. As a trusted manufacturer with a global supply network, we continue to innovate, offering businesses worldwide a premium and eco-conscious alternative to traditional beverage containers.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className='home-content-letter-sub pt-4 pt-md-5'>
                <Container>
                    <Row className='gy-3'>
                        <Col className='col-12'>
                            <div className='img-holder' data-aos="zoom-in" data-aos-delay="500">
                                <img src={require('../../assets/images/7e95882315225ecd7e8efd431936781e.jpeg')} alt="" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default ContentLetter